import React from "react";

// De omlijsting die alle drie de kolommen delen: een kop met een titel links
// en een label rechts, en daaronder de inhoud.
const Card = ({ title, label, labelHighlight = false, className = "", children }) => (
  <div className={`card${className ? ` ${className}` : ""}`}>
    <div className="card-head">
      <h3 className="card-title">{title}</h3>
      <h3 className={`card-title${labelHighlight ? " hl" : ""}`}>{label}</h3>
    </div>
    {children}
  </div>
);

export default Card;
